import Vue from 'vue'
import Router from 'vue-router'
import 'swiper/dist/css/swiper.css'

if (process.browser) {
  const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr')
  Vue.use(VueAwesomeSwiper)
}

Vue.use(Router)

export function createRouter () {
	const router = new Router({
		mode: 'history',
		routes: [
			{
				path: '/protocol',
				name: 'protocol',
				component: () => import('@/components/public/protocol/Protocol.vue')
			},
			{
				path: '/secret',
				name: 'secret',
				component: () => import('@/components/public/protocol/Secret.vue')
			},
			{
				path: '/404',
				name: '404',
				component: () => import('@/components/public/404/NoFound.vue')
      },
      {
        path: '/orderGuide',
        name: 'orderGuide',
        component: () => import('@/components/orderList/OrderGuide.vue')
      },
      {
        path: '/diagnosisCourse',
        name: 'diaCourse',
        component: () => import('@/components/diagnosisCourse/index.vue'),
        redirect: {name: 'diaDetail'},
        children: [
            // 诊断课详情
            {
                path: '/',
                name: 'diaDetail',
                component: () => import('@/components/diagnosisCourse/detail/diaDetail.vue')
            },
            // 诊断课时间选择
            {
                path: 'chooseTime',
                name: 'chooseTime',
                component: () => import('@/components/diagnosisCourse/detail/chooseTime.vue')
            },
            // 诊断课档案填写
            {
                path: 'studentInfo',
                name: 'studentInfo',
                component: () => import('@/components/diagnosisCourse/studentInfo/studentInfo.vue')
            },
            // 诊断课档案填写
            {
                path: 'schoolSearch',
                name: 'schoolSearch',
                component: () => import('@/components/diagnosisCourse/studentInfo/schoolSearch.vue')
            },
            // 诊断课支付成
            {
                path: 'paySuccess',
                name: 'paySuccess',
                component: () => import('@/components/diagnosisCourse/detail/diaDetail.vue')
            }
        ]
    }, {
				path: '/',
				redirect: '/bj'
      },
      {
        path: '/:city',
        name: 'Home',
				component: () => import('@/components/homePage/home/Home.vue')
      },
      {
				//非志康城市首页
				path: '/:city/noline',
				name: 'notOnline',
				component: () => import('@/components/homePage/notOnline/NotOnline.vue')
			},
			{
				path: '/:city/changeCity',
				name: 'changeCity',
				component: () => import('@/components/homePage/home/changeCity/changeCity.vue')
			},
			{
				path: '/:city/orderSuccess',
				name: 'orderSuccess',
				component: () => import('@/components/public/orderSuccess/OrderSuccess.vue')
			},
			{
				path: '/:city/onlineOneToOne',
				name: 'onlineOneToOne',
				component: () => import('@/components/homePage/onlineOneToOne/OnlineOneToOne.vue')
			},
			{
				path: '/:city/faceOneToOne',
				name: 'faceOneToOne',
				component: () => import('@/components/homePage/faceOneToOne/FaceOneToOne.vue')
			},
			{
				path: '/:city/faceEightClass',
				name: 'faceEightClass',
				component: () => import('@/components/homePage/faceEightClass/FaceEightClass.vue')
			},
			{
				path: '/:city/course',
				name: 'course',
				component: () => import('@/components/courseCenter/Course.vue'),
				children: [
					{
						path: 'class',
						name: 'courses',
            component: () => import('@/components/courseCenter/one/One.vue')
					},
					{
						path: 'faceToface',
						name: 'faceToface',
						component: () => import('@/components/courseCenter/one/One.vue')
					},
					{
						path: 'group',
						name: 'group',
						component: () => import('@/components/courseCenter/eight/Eight.vue')
					},
					{
						path: 'online',
						name: 'online',
						component: () => import('@/components/courseCenter/online/Online.vue')
          },
          {
						path: 'groupForOnline',
						name: 'groupForOnline',
						component: () => import('@/components/courseCenter/groupOnline/GroupOnline.vue')
					}
				]
      },
      {
        // 非智康城市，选课中心，只有在线1对1和8人班
				path: '/:city/noline/course',
				name: 'qtCourse',
				component: () => import('@/components/courseCenter/Course.vue'),
				children: [
					{
						path: 'class',
						name: 'qtCourses',
            component: () => import('@/components/courseCenter/online/Online.vue')
					},
					{
						path: 'online',
            name: 'qtOnline',
            alias: ['faceToface', 'group'],
						component: () => import('@/components/courseCenter/online/Online.vue')
          },
          {
						path: 'groupForOnline',
						name: 'qtGroupForOnline',
						component: () => import('@/components/courseCenter/groupOnline/GroupOnline.vue')
					}
				]
			},
			{
				path: '/:city/conditions',
				name: 'conditions',
				component: () => import('@/components/courseCenter/public/conditions/Conditions.vue')
			},

      {
        path: '/:city/qq',
        name: 'qq',
        component: () => import('@/components/public/qq/Qq.vue')
      },
      {
        path: '/:city/order',
        name: 'order',
        component: () => import('@/components/courseCenter/public/order/Order.vue')
      },
      {
        path: '/:city/detail/:courseId',
        name: 'courseDetail',
        component: () => import('@/components/courseCenter/detail/course/CourseDetail.vue')
      },
      {
        path: '/:city/oneDetail',
        name: 'oneDetail',
        component: () => import('@/components/courseCenter/detail/one/OneDetail.vue')
      },
      {
        path: '/:city/eightDetail',
        name: 'eightDetail',
        component: () => import('@/components/courseCenter/detail/eight/EightDetail.vue')
      },
      {
        path: '/:city/onlineDetail',
        name: 'onlineDetail',
        component: () => import('@/components/courseCenter/detail/online/OnlineDetail.vue')
      },
      {
        path: '/:city/mine',
        name: 'mine',
        component: () => import('@/components/mine/Mine.vue')
      },
      {
        path: '/:city/related',
        name: 'related',
        component: () => import('@/components/mine/related/Related.vue')
      },
      {
        path: '/:city/login',
        name: 'login',
        component: () => import('@/components/mine/login/Login.vue')
      },
      {
        path: '/:city/download',
        name: 'download',
        component: () => import('@/components/public/download/Download.vue')
      },
      {
        path: '/:city/reset',
        name: 'reset',
        component: () => import('@/components/mine/reset/Reset.vue')
      },
      {
        path: '/:city/phone',
        name: 'phone',
        component: () => import('@/components/mine/reset/Phone.vue')
      },
      {
        path: '/:city/map',
        name: 'map',
        component: () => import('@/components/public/map/Map.vue')
      },
      {
        path: '/:city/ordered',
        name: 'ordered',
        component: () => import('@/components/courseCenter/ordered/Ordered.vue')
      },
      {
        path: '/:city/courseGo',
        name: 'courseGo',
        component: () => import('@/components/courseCenter/courseGo/CourseGo.vue')
      },
      {
        path: '/:city/about',
        name: 'about',
        component: () => import('@/components/mine/aboutUs/AboutUs.vue')
      }, {
        path: '/:city/feedback',
        name: 'feedback',
        component: () => import('@/components/feedback/Feedback.vue')
      }, {
        path: '/:city/feedback/:type',
        name: 'feedbackInfo',
        component: () => import('@/components/feedback/FeedbackInfo.vue')
      }, {
        path: '/:city/feedback/:type/success',
        name: 'feedbackSuccess',
        component: () => import('@/components/feedback/FeedbackSuccess.vue')
      }, {
        path: '/:city/supplementaryCardInfo',
        name: 'supplementaryCardInfo',
        component: () => import('@/components/studentCard/SupplementaryCardInfo.vue')
      }, {
        path: '/:city/orderList',
        name: 'orderList',
        component: () => import('@/components/orderList/orderList.vue')
      }, {
        path: '/:city/studentCardList',
        name: 'studentCardList',
        component: () => import('@/components/studentCard/studentCardList.vue')
      }, {
        path: '/:city/buyEightCourseInfo',
        name: 'buyEightCourseInfo',
        component: () => import('@/components/courseCenter/newsign/BuyEightCourseInfo')
      }, {
        path: '/:city/newsign',
        name: 'newsign',
        component: () => import('@/components/courseCenter/newsign')
      }
    ]
  })

  router.beforeEach((to, from, next) => {
    console.log('to.name', to.name)
    if (['Home'].includes(to.name)) {
      location.href = 'https://m.xesvip.com/';
    }
    if (to.matched.length === 0) {
      from.name ? next({
        name: from.name
      }) : next('/404');
    } else {
      next(); //如果匹配到正确跳转
    }
  });

  return router;
}





// WEBPACK FOOTER //
// ./src/router/index.js